export default __webpack_public_path__ + "static/bubble-with-categories-2cd26dca3ae6cc8704eb3f02dd525bba.png";